/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../libs/graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RouteBuilderValidateRouteInternalMutationVariables = Types.Exact<{
  segments: Array<Types.TripSegmentInput> | Types.TripSegmentInput
  fleetId?: Types.InputMaybe<Types.Scalars['String']['input']>
  useFleetOsRoute?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
  useStopResolver?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type RouteBuilderValidateRouteInternalMutation = {
  __typename?: 'Mutation'
  validateRouteInternal: {
    __typename?: 'RouteBuilderValidationResult'
    segments: Array<{
      __typename?: 'TripSegment'
      id: string
      sequenceId: number
      metadata: Array<Array<string>>
      destination: {
        __typename?: 'TripGeolocation'
        latitude: number
        longitude: number
      } | null
      stop: {
        __typename?: 'TripDestination'
        desiredAddress: string
        snappedAddress: string
        oddElementType: Types.TripOddElementType
        desiredLocation: {
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        } | null
        snappedLocation: {
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        } | null
        destinationBehavior: {
          __typename?: 'TripDestinationBehavior'
          stopType: Types.TripStopType
          types: Array<Types.DestinationType>
        } | null
      } | null
      route: {
        __typename?: 'TripRoute'
        etaSeconds: number
        distanceMeters: number
        coordinates: Array<{
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        }>
      } | null
    }>
    routeViolations: Array<{
      __typename?: 'RouteViolation'
      violationType: Types.RouteViolationType
      legIndex: number
      geolocation: Array<{
        __typename?: 'TripGeolocation'
        latitude: number
        longitude: number
      }>
    }>
  } | null
}

export type RouteBuilderValidateTripMutationVariables = Types.Exact<{
  vin: Types.Scalars['String']['input']
  segments: Array<Types.TripSegmentInput> | Types.TripSegmentInput
  useStopResolver?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type RouteBuilderValidateTripMutation = {
  __typename?: 'Mutation'
  validateTrip: {
    __typename?: 'ValidateTripResult'
    segments: Array<{
      __typename?: 'TripSegment'
      id: string
      sequenceId: number
      metadata: Array<Array<string>>
      destination: {
        __typename?: 'TripGeolocation'
        latitude: number
        longitude: number
      } | null
      stop: {
        __typename?: 'TripDestination'
        desiredAddress: string
        snappedAddress: string
        oddElementType: Types.TripOddElementType
        desiredLocation: {
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        } | null
        snappedLocation: {
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        } | null
        destinationBehavior: {
          __typename?: 'TripDestinationBehavior'
          stopType: Types.TripStopType
          types: Array<Types.DestinationType>
        } | null
      } | null
      route: {
        __typename?: 'TripRoute'
        etaSeconds: number
        distanceMeters: number
        coordinates: Array<{
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        }>
      } | null
    }>
    routeViolations: Array<{
      __typename?: 'RouteViolation'
      violationType: Types.RouteViolationType
      legIndex: number
      geolocation: Array<{
        __typename?: 'TripGeolocation'
        latitude: number
        longitude: number
      }>
    }>
  } | null
}

export type RouteBuilderValidateRouteSdsMutationVariables = Types.Exact<{
  route: Array<Types.TripGeolocationInput> | Types.TripGeolocationInput
  fleetId: Types.Scalars['String']['input']
}>

export type RouteBuilderValidateRouteSdsMutation = {
  __typename?: 'Mutation'
  validateRouteSds: {
    __typename?: 'ValidateRouteSdsResult'
    mapValidations: Array<{
      __typename?: 'MapValidation'
      success: boolean
      map: string
      message: string
      routeSegments: Array<{
        __typename?: 'SdsRouteSegment'
        startIndex: number
        endIndex: number
        length: number
        drivable: boolean
        reason: Types.ValidationFailureReason
      }>
      route: Array<{
        __typename?: 'TripGeolocation'
        latitude: number
        longitude: number
      }>
    }>
  } | null
}

export type RouteBuilderCreateSavedTripMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input']
  tripId?: Types.InputMaybe<Types.Scalars['String']['input']>
  type: Types.TripType
  segments: Array<Types.TripSegmentInput> | Types.TripSegmentInput
  metroId: Types.Scalars['Int']['input']
  description?: Types.InputMaybe<Types.Scalars['String']['input']>
  metadata?: Types.InputMaybe<
    | Array<
        | Array<Types.Scalars['String']['input']>
        | Types.Scalars['String']['input']
      >
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
  >
  assignedVtrs?: Types.InputMaybe<
    Array<Types.AssignedVtrInput> | Types.AssignedVtrInput
  >
  allWaypointsMode?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type RouteBuilderCreateSavedTripMutation = {
  __typename?: 'Mutation'
  createSavedTrip: {
    __typename?: 'SavedTripEntry'
    id: string
    name: string
  } | null
}

export type RouteBuilderUpdateSavedTripMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input']
  name: Types.Scalars['String']['input']
  tripId?: Types.InputMaybe<Types.Scalars['String']['input']>
  type: Types.TripType
  segments: Array<Types.TripSegmentInput> | Types.TripSegmentInput
  description?: Types.InputMaybe<Types.Scalars['String']['input']>
  metadata?: Types.InputMaybe<
    | Array<
        | Array<Types.Scalars['String']['input']>
        | Types.Scalars['String']['input']
      >
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
  >
  assignedVtrs?: Types.InputMaybe<
    Array<Types.AssignedVtrInput> | Types.AssignedVtrInput
  >
  allWaypointsMode?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type RouteBuilderUpdateSavedTripMutation = {
  __typename?: 'Mutation'
  updateSavedTrip: {
    __typename?: 'SavedTripEntry'
    id: string
    name: string
    description: string
    assignedVtrs: Array<{
      __typename?: 'AssignedVtr'
      vtr: string
      codebeamerIds: Array<string>
    }>
  } | null
}

export type RouteBuilderAssignTripMutationVariables = Types.Exact<{
  vin: Types.Scalars['String']['input']
  segments: Array<Types.TripSegmentInput> | Types.TripSegmentInput
  type: Types.TripType
  metadata?: Types.InputMaybe<
    | Array<
        | Array<Types.Scalars['String']['input']>
        | Types.Scalars['String']['input']
      >
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
  >
  useStopResolver?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type RouteBuilderAssignTripMutation = {
  __typename?: 'Mutation'
  assignTrip: { __typename?: 'TmpTrip'; id: string; vin: string } | null
}

export type RouteBuilderSavedRouteDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input']
}>

export type RouteBuilderSavedRouteDetailsQuery = {
  __typename?: 'Query'
  savedRouteDetails: {
    __typename?: 'SavedRouteDetails'
    id: string
    name: string
    description: string
    metroId: number
    isArchived: boolean
    distance: number
    createdMs: number
    updatedMs: number
    assignedVtrs: Array<{
      __typename?: 'AssignedVtr'
      vtr: string
      codebeamerIds: Array<string>
    }>
    trip: {
      __typename?: 'TmpTrip'
      id: string
      type: Types.TripType
      allWaypointsMode: boolean
      segments: Array<{
        __typename?: 'TripSegmentWithStatus'
        segment: {
          __typename?: 'TripSegment'
          id: string
          sequenceId: number
          metadata: Array<Array<string>>
          numPassengers: number
          destination: {
            __typename?: 'TripGeolocation'
            latitude: number
            longitude: number
          } | null
          stop: {
            __typename?: 'TripDestination'
            desiredAddress: string
            snappedAddress: string
            oddElementType: Types.TripOddElementType
            desiredLocation: {
              __typename?: 'TripGeolocation'
              latitude: number
              longitude: number
              heading: number
            } | null
            snappedLocation: {
              __typename?: 'TripGeolocation'
              latitude: number
              longitude: number
              heading: number
            } | null
            destinationBehavior: {
              __typename?: 'TripDestinationBehavior'
              stopType: Types.TripStopType
              types: Array<Types.DestinationType>
            } | null
          } | null
          route: {
            __typename?: 'TripRoute'
            etaSeconds: number
            distanceMeters: number
            coordinates: Array<{
              __typename?: 'TripGeolocation'
              latitude: number
              longitude: number
            }>
          } | null
        } | null
      }>
    } | null
  } | null
}

export type RouteBuilderVtrTicketsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type RouteBuilderVtrTicketsQuery = {
  __typename?: 'Query'
  vtrTickets: Array<{
    __typename?: 'VtrJiraTicket'
    key: string
    status: string
    summary: string
    location: string
    missionType: string
    fleetTarget: string
  }>
}

export type RouteBuilderVtrDataQueryVariables = Types.Exact<{
  jiraTicketNumber: Types.Scalars['String']['input']
}>

export type RouteBuilderVtrDataQuery = {
  __typename?: 'Query'
  vtrData: {
    __typename?: 'VtrData'
    key: string
    type: string
    resolution: string
    priority: string
    fixVersion: string
    securityLevel: string
    epicLink: string
    location: string
    testType: string
    testSpecification: string
    riskLevel: string
    targetCompoundRelease: string
    requestedSoftwareVersion: string
    mapVersion: string
    label: string
    deviationPermission: string
    description: string
    status: string
    codebeamerId: string
    feature: string
    sprint: string
    links: string
    cbData: Array<{
      __typename?: 'CbPreview'
      tracker: string
      parent: string
      status: string
      type: string
      submittedBy: string
      modifiedBy: string
      numUniqueElements: number
      location: string
      targetNumPerElement: number
      targetUnit: string
      targetConstraints: string
      fleetTarget: string
      codebeamerTestcaseId: string
      oddElementTypes: Array<string>
      taxonomies: Array<string>
    }>
  } | null
}

export type RouteBuilderOverwatchFleetsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type RouteBuilderOverwatchFleetsQuery = {
  __typename?: 'Query'
  overwatchFleets: Array<{
    __typename?: 'OverwatchFleet'
    id: string
    name: string
    metropolisId: number
    integrationId: string
  }>
}

export type RouteBuilderGenerateRouteForRequirementsMutationVariables =
  Types.Exact<{
    routeRequirements:
      | Array<Types.RouteRequirementInput>
      | Types.RouteRequirementInput
    boundingBox?: Types.InputMaybe<Types.GeoBoundingBoxInput>
  }>

export type RouteBuilderGenerateRouteForRequirementsMutation = {
  __typename?: 'Mutation'
  generateRouteForRequirements: {
    __typename?: 'RouteBuilderValidationResult'
    segments: Array<{
      __typename?: 'TripSegment'
      id: string
      sequenceId: number
      destination: {
        __typename?: 'TripGeolocation'
        latitude: number
        longitude: number
      } | null
      stop: {
        __typename?: 'TripDestination'
        desiredAddress: string
        oddElementType: Types.TripOddElementType
        desiredLocation: {
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        } | null
      } | null
      route: {
        __typename?: 'TripRoute'
        etaSeconds: number
        distanceMeters: number
        coordinates: Array<{
          __typename?: 'TripGeolocation'
          latitude: number
          longitude: number
        }>
      } | null
    }>
    routeViolations: Array<{
      __typename?: 'RouteViolation'
      violationType: Types.RouteViolationType
      legIndex: number
    }>
  } | null
}

export type RouteBuilderOddElementsForRouteQueryVariables = Types.Exact<{
  metroId: Types.Scalars['Int']['input']
  taxonomies?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >
  routes: Array<Types.RouteInput> | Types.RouteInput
}>

export type RouteBuilderOddElementsForRouteQuery = {
  __typename?: 'Query'
  oddElementsForRoute: Array<{
    __typename?: 'RouteWithElements'
    routeCoordinates: Array<{
      __typename?: 'Geolocation'
      latitude: number
      longitude: number
    }>
    oddElements: Array<{
      __typename?: 'ODDElement'
      taxonomy: string
      elementType: Types.OddElementType
      location: {
        __typename?: 'Geolocation'
        latitude: number
        longitude: number
      } | null
    }>
  }>
}

export type RouteBuilderTripAnnotationsQueryVariables = Types.Exact<{
  tripId?: Types.InputMaybe<Types.Scalars['String']['input']>
  vtrId?: Types.InputMaybe<Types.Scalars['String']['input']>
}>

export type RouteBuilderTripAnnotationsQuery = {
  __typename?: 'Query'
  tripAnnotations: Array<{
    __typename?: 'TripAnnotation'
    annotationId: string
    recordedAtMs: number
    vehicleId: string
    driverId: string
    severity: Types.TripAnnotationSeverity
    tripId: string | null
    vtrId: string | null
    transcriptionStatus: Types.TripAnnotationTranscriptionStatus
    transcript: string | null
    location: {
      __typename?: 'TripGeolocation'
      latitude: number
      longitude: number
    }
  }>
}

export const RouteBuilderValidateRouteInternalDocument = gql`
    mutation RouteBuilderValidateRouteInternal($segments: [TripSegmentInput!]!, $fleetId: String, $useFleetOsRoute: Boolean, $useStopResolver: Boolean) {
  validateRouteInternal(
    segments: $segments
    fleetId: $fleetId
    useFleetOsRoute: $useFleetOsRoute
    useStopResolver: $useStopResolver
  ) {
    segments {
      id
      sequenceId
      metadata
      destination {
        latitude
        longitude
      }
      stop {
        desiredLocation {
          latitude
          longitude
        }
        snappedLocation {
          latitude
          longitude
        }
        desiredAddress
        snappedAddress
        oddElementType
        destinationBehavior {
          stopType
          types
        }
      }
      route {
        coordinates {
          latitude
          longitude
        }
        etaSeconds
        distanceMeters
      }
    }
    routeViolations {
      violationType
      legIndex
      geolocation {
        latitude
        longitude
      }
    }
  }
}
    `
export type RouteBuilderValidateRouteInternalMutationFn =
  Apollo.MutationFunction<
    RouteBuilderValidateRouteInternalMutation,
    RouteBuilderValidateRouteInternalMutationVariables
  >

/**
 * __useRouteBuilderValidateRouteInternalMutation__
 *
 * To run a mutation, you first call `useRouteBuilderValidateRouteInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderValidateRouteInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderValidateRouteInternalMutation, { data, loading, error }] = useRouteBuilderValidateRouteInternalMutation({
 *   variables: {
 *      segments: // value for 'segments'
 *      fleetId: // value for 'fleetId'
 *      useFleetOsRoute: // value for 'useFleetOsRoute'
 *      useStopResolver: // value for 'useStopResolver'
 *   },
 * });
 */
export function useRouteBuilderValidateRouteInternalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderValidateRouteInternalMutation,
    RouteBuilderValidateRouteInternalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderValidateRouteInternalMutation,
    RouteBuilderValidateRouteInternalMutationVariables
  >(RouteBuilderValidateRouteInternalDocument, options)
}
export type RouteBuilderValidateRouteInternalMutationHookResult = ReturnType<
  typeof useRouteBuilderValidateRouteInternalMutation
>
export type RouteBuilderValidateRouteInternalMutationResult =
  Apollo.MutationResult<RouteBuilderValidateRouteInternalMutation>
export type RouteBuilderValidateRouteInternalMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderValidateRouteInternalMutation,
    RouteBuilderValidateRouteInternalMutationVariables
  >
export const RouteBuilderValidateTripDocument = gql`
    mutation RouteBuilderValidateTrip($vin: String!, $segments: [TripSegmentInput!]!, $useStopResolver: Boolean) {
  validateTrip(vin: $vin, segments: $segments, useStopResolver: $useStopResolver) {
    segments {
      id
      sequenceId
      metadata
      destination {
        latitude
        longitude
      }
      stop {
        desiredLocation {
          latitude
          longitude
        }
        snappedLocation {
          latitude
          longitude
        }
        desiredAddress
        snappedAddress
        oddElementType
        destinationBehavior {
          stopType
          types
        }
      }
      route {
        coordinates {
          latitude
          longitude
        }
        etaSeconds
        distanceMeters
      }
    }
    routeViolations {
      violationType
      legIndex
      geolocation {
        latitude
        longitude
      }
    }
  }
}
    `
export type RouteBuilderValidateTripMutationFn = Apollo.MutationFunction<
  RouteBuilderValidateTripMutation,
  RouteBuilderValidateTripMutationVariables
>

/**
 * __useRouteBuilderValidateTripMutation__
 *
 * To run a mutation, you first call `useRouteBuilderValidateTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderValidateTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderValidateTripMutation, { data, loading, error }] = useRouteBuilderValidateTripMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *      segments: // value for 'segments'
 *      useStopResolver: // value for 'useStopResolver'
 *   },
 * });
 */
export function useRouteBuilderValidateTripMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderValidateTripMutation,
    RouteBuilderValidateTripMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderValidateTripMutation,
    RouteBuilderValidateTripMutationVariables
  >(RouteBuilderValidateTripDocument, options)
}
export type RouteBuilderValidateTripMutationHookResult = ReturnType<
  typeof useRouteBuilderValidateTripMutation
>
export type RouteBuilderValidateTripMutationResult =
  Apollo.MutationResult<RouteBuilderValidateTripMutation>
export type RouteBuilderValidateTripMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderValidateTripMutation,
    RouteBuilderValidateTripMutationVariables
  >
export const RouteBuilderValidateRouteSdsDocument = gql`
    mutation RouteBuilderValidateRouteSds($route: [TripGeolocationInput!]!, $fleetId: String!) {
  validateRouteSds(route: $route, fleetId: $fleetId) {
    mapValidations {
      success
      map
      message
      routeSegments {
        startIndex
        endIndex
        length
        drivable
        reason
      }
      route {
        latitude
        longitude
      }
    }
  }
}
    `
export type RouteBuilderValidateRouteSdsMutationFn = Apollo.MutationFunction<
  RouteBuilderValidateRouteSdsMutation,
  RouteBuilderValidateRouteSdsMutationVariables
>

/**
 * __useRouteBuilderValidateRouteSdsMutation__
 *
 * To run a mutation, you first call `useRouteBuilderValidateRouteSdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderValidateRouteSdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderValidateRouteSdsMutation, { data, loading, error }] = useRouteBuilderValidateRouteSdsMutation({
 *   variables: {
 *      route: // value for 'route'
 *      fleetId: // value for 'fleetId'
 *   },
 * });
 */
export function useRouteBuilderValidateRouteSdsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderValidateRouteSdsMutation,
    RouteBuilderValidateRouteSdsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderValidateRouteSdsMutation,
    RouteBuilderValidateRouteSdsMutationVariables
  >(RouteBuilderValidateRouteSdsDocument, options)
}
export type RouteBuilderValidateRouteSdsMutationHookResult = ReturnType<
  typeof useRouteBuilderValidateRouteSdsMutation
>
export type RouteBuilderValidateRouteSdsMutationResult =
  Apollo.MutationResult<RouteBuilderValidateRouteSdsMutation>
export type RouteBuilderValidateRouteSdsMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderValidateRouteSdsMutation,
    RouteBuilderValidateRouteSdsMutationVariables
  >
export const RouteBuilderCreateSavedTripDocument = gql`
    mutation RouteBuilderCreateSavedTrip($name: String!, $tripId: String, $type: TripType!, $segments: [TripSegmentInput!]!, $metroId: Int!, $description: String, $metadata: [[String!]!], $assignedVtrs: [AssignedVtrInput!], $allWaypointsMode: Boolean) {
  createSavedTrip(
    name: $name
    tripId: $tripId
    type: $type
    segments: $segments
    metroId: $metroId
    description: $description
    metadata: $metadata
    assignedVtrs: $assignedVtrs
    allWaypointsMode: $allWaypointsMode
  ) {
    id
    name
  }
}
    `
export type RouteBuilderCreateSavedTripMutationFn = Apollo.MutationFunction<
  RouteBuilderCreateSavedTripMutation,
  RouteBuilderCreateSavedTripMutationVariables
>

/**
 * __useRouteBuilderCreateSavedTripMutation__
 *
 * To run a mutation, you first call `useRouteBuilderCreateSavedTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderCreateSavedTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderCreateSavedTripMutation, { data, loading, error }] = useRouteBuilderCreateSavedTripMutation({
 *   variables: {
 *      name: // value for 'name'
 *      tripId: // value for 'tripId'
 *      type: // value for 'type'
 *      segments: // value for 'segments'
 *      metroId: // value for 'metroId'
 *      description: // value for 'description'
 *      metadata: // value for 'metadata'
 *      assignedVtrs: // value for 'assignedVtrs'
 *      allWaypointsMode: // value for 'allWaypointsMode'
 *   },
 * });
 */
export function useRouteBuilderCreateSavedTripMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderCreateSavedTripMutation,
    RouteBuilderCreateSavedTripMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderCreateSavedTripMutation,
    RouteBuilderCreateSavedTripMutationVariables
  >(RouteBuilderCreateSavedTripDocument, options)
}
export type RouteBuilderCreateSavedTripMutationHookResult = ReturnType<
  typeof useRouteBuilderCreateSavedTripMutation
>
export type RouteBuilderCreateSavedTripMutationResult =
  Apollo.MutationResult<RouteBuilderCreateSavedTripMutation>
export type RouteBuilderCreateSavedTripMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderCreateSavedTripMutation,
    RouteBuilderCreateSavedTripMutationVariables
  >
export const RouteBuilderUpdateSavedTripDocument = gql`
    mutation RouteBuilderUpdateSavedTrip($id: String!, $name: String!, $tripId: String, $type: TripType!, $segments: [TripSegmentInput!]!, $description: String, $metadata: [[String!]!], $assignedVtrs: [AssignedVtrInput!], $allWaypointsMode: Boolean) {
  updateSavedTrip(
    id: $id
    name: $name
    tripId: $tripId
    type: $type
    segments: $segments
    description: $description
    metadata: $metadata
    assignedVtrs: $assignedVtrs
    allWaypointsMode: $allWaypointsMode
  ) {
    id
    name
    description
    assignedVtrs {
      vtr
      codebeamerIds
    }
  }
}
    `
export type RouteBuilderUpdateSavedTripMutationFn = Apollo.MutationFunction<
  RouteBuilderUpdateSavedTripMutation,
  RouteBuilderUpdateSavedTripMutationVariables
>

/**
 * __useRouteBuilderUpdateSavedTripMutation__
 *
 * To run a mutation, you first call `useRouteBuilderUpdateSavedTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderUpdateSavedTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderUpdateSavedTripMutation, { data, loading, error }] = useRouteBuilderUpdateSavedTripMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      tripId: // value for 'tripId'
 *      type: // value for 'type'
 *      segments: // value for 'segments'
 *      description: // value for 'description'
 *      metadata: // value for 'metadata'
 *      assignedVtrs: // value for 'assignedVtrs'
 *      allWaypointsMode: // value for 'allWaypointsMode'
 *   },
 * });
 */
export function useRouteBuilderUpdateSavedTripMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderUpdateSavedTripMutation,
    RouteBuilderUpdateSavedTripMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderUpdateSavedTripMutation,
    RouteBuilderUpdateSavedTripMutationVariables
  >(RouteBuilderUpdateSavedTripDocument, options)
}
export type RouteBuilderUpdateSavedTripMutationHookResult = ReturnType<
  typeof useRouteBuilderUpdateSavedTripMutation
>
export type RouteBuilderUpdateSavedTripMutationResult =
  Apollo.MutationResult<RouteBuilderUpdateSavedTripMutation>
export type RouteBuilderUpdateSavedTripMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderUpdateSavedTripMutation,
    RouteBuilderUpdateSavedTripMutationVariables
  >
export const RouteBuilderAssignTripDocument = gql`
    mutation RouteBuilderAssignTrip($vin: String!, $segments: [TripSegmentInput!]!, $type: TripType!, $metadata: [[String!]!], $useStopResolver: Boolean) {
  assignTrip(
    vin: $vin
    segments: $segments
    type: $type
    metadata: $metadata
    useStopResolver: $useStopResolver
  ) {
    id
    vin
  }
}
    `
export type RouteBuilderAssignTripMutationFn = Apollo.MutationFunction<
  RouteBuilderAssignTripMutation,
  RouteBuilderAssignTripMutationVariables
>

/**
 * __useRouteBuilderAssignTripMutation__
 *
 * To run a mutation, you first call `useRouteBuilderAssignTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderAssignTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderAssignTripMutation, { data, loading, error }] = useRouteBuilderAssignTripMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *      segments: // value for 'segments'
 *      type: // value for 'type'
 *      metadata: // value for 'metadata'
 *      useStopResolver: // value for 'useStopResolver'
 *   },
 * });
 */
export function useRouteBuilderAssignTripMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderAssignTripMutation,
    RouteBuilderAssignTripMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderAssignTripMutation,
    RouteBuilderAssignTripMutationVariables
  >(RouteBuilderAssignTripDocument, options)
}
export type RouteBuilderAssignTripMutationHookResult = ReturnType<
  typeof useRouteBuilderAssignTripMutation
>
export type RouteBuilderAssignTripMutationResult =
  Apollo.MutationResult<RouteBuilderAssignTripMutation>
export type RouteBuilderAssignTripMutationOptions = Apollo.BaseMutationOptions<
  RouteBuilderAssignTripMutation,
  RouteBuilderAssignTripMutationVariables
>
export const RouteBuilderSavedRouteDetailsDocument = gql`
    query RouteBuilderSavedRouteDetails($id: String!) {
  savedRouteDetails(routeId: $id) {
    id
    name
    description
    metroId
    isArchived
    distance
    createdMs
    updatedMs
    assignedVtrs {
      vtr
      codebeamerIds
    }
    trip {
      id
      type
      allWaypointsMode
      segments {
        segment {
          id
          sequenceId
          metadata
          destination {
            latitude
            longitude
          }
          stop {
            desiredLocation {
              latitude
              longitude
              heading
            }
            snappedLocation {
              latitude
              longitude
              heading
            }
            desiredAddress
            snappedAddress
            oddElementType
            destinationBehavior {
              stopType
              types
            }
          }
          numPassengers
          route {
            coordinates {
              latitude
              longitude
            }
            etaSeconds
            distanceMeters
          }
        }
      }
    }
  }
}
    `

/**
 * __useRouteBuilderSavedRouteDetailsQuery__
 *
 * To run a query within a React component, call `useRouteBuilderSavedRouteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderSavedRouteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderSavedRouteDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRouteBuilderSavedRouteDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderSavedRouteDetailsQuery,
    RouteBuilderSavedRouteDetailsQueryVariables
  > &
    (
      | {
          variables: RouteBuilderSavedRouteDetailsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderSavedRouteDetailsQuery,
    RouteBuilderSavedRouteDetailsQueryVariables
  >(RouteBuilderSavedRouteDetailsDocument, options)
}
export function useRouteBuilderSavedRouteDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderSavedRouteDetailsQuery,
    RouteBuilderSavedRouteDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderSavedRouteDetailsQuery,
    RouteBuilderSavedRouteDetailsQueryVariables
  >(RouteBuilderSavedRouteDetailsDocument, options)
}
// @ts-ignore
export function useRouteBuilderSavedRouteDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderSavedRouteDetailsQuery,
    RouteBuilderSavedRouteDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedRouteDetailsQuery,
  RouteBuilderSavedRouteDetailsQueryVariables
>
export function useRouteBuilderSavedRouteDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedRouteDetailsQuery,
        RouteBuilderSavedRouteDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedRouteDetailsQuery | undefined,
  RouteBuilderSavedRouteDetailsQueryVariables
>
export function useRouteBuilderSavedRouteDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedRouteDetailsQuery,
        RouteBuilderSavedRouteDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderSavedRouteDetailsQuery,
    RouteBuilderSavedRouteDetailsQueryVariables
  >(RouteBuilderSavedRouteDetailsDocument, options)
}
export type RouteBuilderSavedRouteDetailsQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRouteDetailsQuery
>
export type RouteBuilderSavedRouteDetailsLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRouteDetailsLazyQuery
>
export type RouteBuilderSavedRouteDetailsSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRouteDetailsSuspenseQuery
>
export type RouteBuilderSavedRouteDetailsQueryResult = Apollo.QueryResult<
  RouteBuilderSavedRouteDetailsQuery,
  RouteBuilderSavedRouteDetailsQueryVariables
>
export const RouteBuilderVtrTicketsDocument = gql`
    query RouteBuilderVtrTickets {
  vtrTickets: vtrJiraTickets {
    key
    status
    summary
    location
    missionType
    fleetTarget
  }
}
    `

/**
 * __useRouteBuilderVtrTicketsQuery__
 *
 * To run a query within a React component, call `useRouteBuilderVtrTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderVtrTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderVtrTicketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRouteBuilderVtrTicketsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RouteBuilderVtrTicketsQuery,
    RouteBuilderVtrTicketsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderVtrTicketsQuery,
    RouteBuilderVtrTicketsQueryVariables
  >(RouteBuilderVtrTicketsDocument, options)
}
export function useRouteBuilderVtrTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderVtrTicketsQuery,
    RouteBuilderVtrTicketsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderVtrTicketsQuery,
    RouteBuilderVtrTicketsQueryVariables
  >(RouteBuilderVtrTicketsDocument, options)
}
// @ts-ignore
export function useRouteBuilderVtrTicketsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderVtrTicketsQuery,
    RouteBuilderVtrTicketsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderVtrTicketsQuery,
  RouteBuilderVtrTicketsQueryVariables
>
export function useRouteBuilderVtrTicketsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderVtrTicketsQuery,
        RouteBuilderVtrTicketsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderVtrTicketsQuery | undefined,
  RouteBuilderVtrTicketsQueryVariables
>
export function useRouteBuilderVtrTicketsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderVtrTicketsQuery,
        RouteBuilderVtrTicketsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderVtrTicketsQuery,
    RouteBuilderVtrTicketsQueryVariables
  >(RouteBuilderVtrTicketsDocument, options)
}
export type RouteBuilderVtrTicketsQueryHookResult = ReturnType<
  typeof useRouteBuilderVtrTicketsQuery
>
export type RouteBuilderVtrTicketsLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderVtrTicketsLazyQuery
>
export type RouteBuilderVtrTicketsSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderVtrTicketsSuspenseQuery
>
export type RouteBuilderVtrTicketsQueryResult = Apollo.QueryResult<
  RouteBuilderVtrTicketsQuery,
  RouteBuilderVtrTicketsQueryVariables
>
export const RouteBuilderVtrDataDocument = gql`
    query RouteBuilderVtrData($jiraTicketNumber: String!) {
  vtrData: vtrData(ticketNumber: $jiraTicketNumber) {
    key
    type
    resolution
    priority
    fixVersion
    securityLevel
    epicLink
    location
    testType
    testSpecification
    riskLevel
    targetCompoundRelease
    requestedSoftwareVersion
    mapVersion
    label
    deviationPermission
    description
    status
    codebeamerId
    feature
    sprint
    links
    cbData {
      tracker
      parent
      status
      type
      submittedBy
      modifiedBy
      numUniqueElements
      location
      targetNumPerElement
      targetUnit
      targetConstraints
      fleetTarget
      codebeamerTestcaseId
      oddElementTypes
      taxonomies
    }
  }
}
    `

/**
 * __useRouteBuilderVtrDataQuery__
 *
 * To run a query within a React component, call `useRouteBuilderVtrDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderVtrDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderVtrDataQuery({
 *   variables: {
 *      jiraTicketNumber: // value for 'jiraTicketNumber'
 *   },
 * });
 */
export function useRouteBuilderVtrDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderVtrDataQuery,
    RouteBuilderVtrDataQueryVariables
  > &
    (
      | { variables: RouteBuilderVtrDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderVtrDataQuery,
    RouteBuilderVtrDataQueryVariables
  >(RouteBuilderVtrDataDocument, options)
}
export function useRouteBuilderVtrDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderVtrDataQuery,
    RouteBuilderVtrDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderVtrDataQuery,
    RouteBuilderVtrDataQueryVariables
  >(RouteBuilderVtrDataDocument, options)
}
// @ts-ignore
export function useRouteBuilderVtrDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderVtrDataQuery,
    RouteBuilderVtrDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderVtrDataQuery,
  RouteBuilderVtrDataQueryVariables
>
export function useRouteBuilderVtrDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderVtrDataQuery,
        RouteBuilderVtrDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderVtrDataQuery | undefined,
  RouteBuilderVtrDataQueryVariables
>
export function useRouteBuilderVtrDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderVtrDataQuery,
        RouteBuilderVtrDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderVtrDataQuery,
    RouteBuilderVtrDataQueryVariables
  >(RouteBuilderVtrDataDocument, options)
}
export type RouteBuilderVtrDataQueryHookResult = ReturnType<
  typeof useRouteBuilderVtrDataQuery
>
export type RouteBuilderVtrDataLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderVtrDataLazyQuery
>
export type RouteBuilderVtrDataSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderVtrDataSuspenseQuery
>
export type RouteBuilderVtrDataQueryResult = Apollo.QueryResult<
  RouteBuilderVtrDataQuery,
  RouteBuilderVtrDataQueryVariables
>
export const RouteBuilderOverwatchFleetsDocument = gql`
    query RouteBuilderOverwatchFleets {
  overwatchFleets {
    id
    name
    metropolisId
    integrationId
  }
}
    `

/**
 * __useRouteBuilderOverwatchFleetsQuery__
 *
 * To run a query within a React component, call `useRouteBuilderOverwatchFleetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderOverwatchFleetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderOverwatchFleetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRouteBuilderOverwatchFleetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RouteBuilderOverwatchFleetsQuery,
    RouteBuilderOverwatchFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderOverwatchFleetsQuery,
    RouteBuilderOverwatchFleetsQueryVariables
  >(RouteBuilderOverwatchFleetsDocument, options)
}
export function useRouteBuilderOverwatchFleetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderOverwatchFleetsQuery,
    RouteBuilderOverwatchFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderOverwatchFleetsQuery,
    RouteBuilderOverwatchFleetsQueryVariables
  >(RouteBuilderOverwatchFleetsDocument, options)
}
// @ts-ignore
export function useRouteBuilderOverwatchFleetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderOverwatchFleetsQuery,
    RouteBuilderOverwatchFleetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderOverwatchFleetsQuery,
  RouteBuilderOverwatchFleetsQueryVariables
>
export function useRouteBuilderOverwatchFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderOverwatchFleetsQuery,
        RouteBuilderOverwatchFleetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderOverwatchFleetsQuery | undefined,
  RouteBuilderOverwatchFleetsQueryVariables
>
export function useRouteBuilderOverwatchFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderOverwatchFleetsQuery,
        RouteBuilderOverwatchFleetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderOverwatchFleetsQuery,
    RouteBuilderOverwatchFleetsQueryVariables
  >(RouteBuilderOverwatchFleetsDocument, options)
}
export type RouteBuilderOverwatchFleetsQueryHookResult = ReturnType<
  typeof useRouteBuilderOverwatchFleetsQuery
>
export type RouteBuilderOverwatchFleetsLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderOverwatchFleetsLazyQuery
>
export type RouteBuilderOverwatchFleetsSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderOverwatchFleetsSuspenseQuery
>
export type RouteBuilderOverwatchFleetsQueryResult = Apollo.QueryResult<
  RouteBuilderOverwatchFleetsQuery,
  RouteBuilderOverwatchFleetsQueryVariables
>
export const RouteBuilderGenerateRouteForRequirementsDocument = gql`
    mutation RouteBuilderGenerateRouteForRequirements($routeRequirements: [RouteRequirementInput!]!, $boundingBox: GeoBoundingBoxInput) {
  generateRouteForRequirements(
    routeRequirements: $routeRequirements
    boundingBox: $boundingBox
  ) {
    segments {
      id
      sequenceId
      destination {
        latitude
        longitude
      }
      stop {
        desiredLocation {
          latitude
          longitude
        }
        desiredAddress
        oddElementType
      }
      route {
        coordinates {
          latitude
          longitude
        }
        etaSeconds
        distanceMeters
      }
    }
    routeViolations {
      violationType
      legIndex
    }
  }
}
    `
export type RouteBuilderGenerateRouteForRequirementsMutationFn =
  Apollo.MutationFunction<
    RouteBuilderGenerateRouteForRequirementsMutation,
    RouteBuilderGenerateRouteForRequirementsMutationVariables
  >

/**
 * __useRouteBuilderGenerateRouteForRequirementsMutation__
 *
 * To run a mutation, you first call `useRouteBuilderGenerateRouteForRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderGenerateRouteForRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderGenerateRouteForRequirementsMutation, { data, loading, error }] = useRouteBuilderGenerateRouteForRequirementsMutation({
 *   variables: {
 *      routeRequirements: // value for 'routeRequirements'
 *      boundingBox: // value for 'boundingBox'
 *   },
 * });
 */
export function useRouteBuilderGenerateRouteForRequirementsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderGenerateRouteForRequirementsMutation,
    RouteBuilderGenerateRouteForRequirementsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderGenerateRouteForRequirementsMutation,
    RouteBuilderGenerateRouteForRequirementsMutationVariables
  >(RouteBuilderGenerateRouteForRequirementsDocument, options)
}
export type RouteBuilderGenerateRouteForRequirementsMutationHookResult =
  ReturnType<typeof useRouteBuilderGenerateRouteForRequirementsMutation>
export type RouteBuilderGenerateRouteForRequirementsMutationResult =
  Apollo.MutationResult<RouteBuilderGenerateRouteForRequirementsMutation>
export type RouteBuilderGenerateRouteForRequirementsMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderGenerateRouteForRequirementsMutation,
    RouteBuilderGenerateRouteForRequirementsMutationVariables
  >
export const RouteBuilderOddElementsForRouteDocument = gql`
    query RouteBuilderOddElementsForRoute($metroId: Int!, $taxonomies: [String!], $routes: [RouteInput!]!) {
  oddElementsForRoute(metroId: $metroId, taxonomies: $taxonomies, routes: $routes) {
    routeCoordinates {
      latitude
      longitude
    }
    oddElements {
      taxonomy
      elementType
      location {
        latitude
        longitude
      }
    }
  }
}
    `

/**
 * __useRouteBuilderOddElementsForRouteQuery__
 *
 * To run a query within a React component, call `useRouteBuilderOddElementsForRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderOddElementsForRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderOddElementsForRouteQuery({
 *   variables: {
 *      metroId: // value for 'metroId'
 *      taxonomies: // value for 'taxonomies'
 *      routes: // value for 'routes'
 *   },
 * });
 */
export function useRouteBuilderOddElementsForRouteQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderOddElementsForRouteQuery,
    RouteBuilderOddElementsForRouteQueryVariables
  > &
    (
      | {
          variables: RouteBuilderOddElementsForRouteQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderOddElementsForRouteQuery,
    RouteBuilderOddElementsForRouteQueryVariables
  >(RouteBuilderOddElementsForRouteDocument, options)
}
export function useRouteBuilderOddElementsForRouteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderOddElementsForRouteQuery,
    RouteBuilderOddElementsForRouteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderOddElementsForRouteQuery,
    RouteBuilderOddElementsForRouteQueryVariables
  >(RouteBuilderOddElementsForRouteDocument, options)
}
// @ts-ignore
export function useRouteBuilderOddElementsForRouteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderOddElementsForRouteQuery,
    RouteBuilderOddElementsForRouteQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderOddElementsForRouteQuery,
  RouteBuilderOddElementsForRouteQueryVariables
>
export function useRouteBuilderOddElementsForRouteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderOddElementsForRouteQuery,
        RouteBuilderOddElementsForRouteQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderOddElementsForRouteQuery | undefined,
  RouteBuilderOddElementsForRouteQueryVariables
>
export function useRouteBuilderOddElementsForRouteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderOddElementsForRouteQuery,
        RouteBuilderOddElementsForRouteQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderOddElementsForRouteQuery,
    RouteBuilderOddElementsForRouteQueryVariables
  >(RouteBuilderOddElementsForRouteDocument, options)
}
export type RouteBuilderOddElementsForRouteQueryHookResult = ReturnType<
  typeof useRouteBuilderOddElementsForRouteQuery
>
export type RouteBuilderOddElementsForRouteLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderOddElementsForRouteLazyQuery
>
export type RouteBuilderOddElementsForRouteSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderOddElementsForRouteSuspenseQuery
>
export type RouteBuilderOddElementsForRouteQueryResult = Apollo.QueryResult<
  RouteBuilderOddElementsForRouteQuery,
  RouteBuilderOddElementsForRouteQueryVariables
>
export const RouteBuilderTripAnnotationsDocument = gql`
    query RouteBuilderTripAnnotations($tripId: String, $vtrId: String) {
  tripAnnotations(tripId: $tripId, vtrId: $vtrId) {
    annotationId
    recordedAtMs
    vehicleId
    driverId
    severity
    location {
      latitude
      longitude
    }
    tripId
    vtrId
    transcriptionStatus
    transcript
  }
}
    `

/**
 * __useRouteBuilderTripAnnotationsQuery__
 *
 * To run a query within a React component, call `useRouteBuilderTripAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderTripAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderTripAnnotationsQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      vtrId: // value for 'vtrId'
 *   },
 * });
 */
export function useRouteBuilderTripAnnotationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RouteBuilderTripAnnotationsQuery,
    RouteBuilderTripAnnotationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderTripAnnotationsQuery,
    RouteBuilderTripAnnotationsQueryVariables
  >(RouteBuilderTripAnnotationsDocument, options)
}
export function useRouteBuilderTripAnnotationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderTripAnnotationsQuery,
    RouteBuilderTripAnnotationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderTripAnnotationsQuery,
    RouteBuilderTripAnnotationsQueryVariables
  >(RouteBuilderTripAnnotationsDocument, options)
}
// @ts-ignore
export function useRouteBuilderTripAnnotationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderTripAnnotationsQuery,
    RouteBuilderTripAnnotationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderTripAnnotationsQuery,
  RouteBuilderTripAnnotationsQueryVariables
>
export function useRouteBuilderTripAnnotationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderTripAnnotationsQuery,
        RouteBuilderTripAnnotationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderTripAnnotationsQuery | undefined,
  RouteBuilderTripAnnotationsQueryVariables
>
export function useRouteBuilderTripAnnotationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderTripAnnotationsQuery,
        RouteBuilderTripAnnotationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderTripAnnotationsQuery,
    RouteBuilderTripAnnotationsQueryVariables
  >(RouteBuilderTripAnnotationsDocument, options)
}
export type RouteBuilderTripAnnotationsQueryHookResult = ReturnType<
  typeof useRouteBuilderTripAnnotationsQuery
>
export type RouteBuilderTripAnnotationsLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderTripAnnotationsLazyQuery
>
export type RouteBuilderTripAnnotationsSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderTripAnnotationsSuspenseQuery
>
export type RouteBuilderTripAnnotationsQueryResult = Apollo.QueryResult<
  RouteBuilderTripAnnotationsQuery,
  RouteBuilderTripAnnotationsQueryVariables
>
